/**
 * appSupportsEditions returns 'true' when:
 *    1. atleast 2 editions are present, and
 *    2. billingSystem is either 'CCP' or undefined ('HAMS' sites are not allowed)
 *
 *    NOTE: the above 'undefined' usecase is for MPAC, where billingSystem is not known
 */
export const appSupportsEditions = _ref => {
  let {
    editions,
    billingSystem
  } = _ref;
  return !!editions && editions.length > 1 && billingSystem !== 'HAMS';
};